export default __webpack_public_path__ + "static/media/vic5.86a61ef7.jpg";